module.exports = __webpack_public_path__ + "static/img/invoiceBg@3x9df2127.png";